import { Stack, styled } from '@mui/material';

export const Container = styled(Stack)({
  height: '100vh',
  width: '33%',
  minWidth: '500px',
  alignItems: 'center',
  overflow: 'hidden',
  justifyContent: 'center',
  position: 'relative'
});

export const ActionsAndButtons = styled(Stack)({
  height: '95%',
  maxHeight: '700px',
  width: '92%',
  maxWidth: '530px',
  margin: 'auto',
  zIndex: 2
});

export const ActionsContainer = styled(Stack)({
  height: '100%',
  position: 'relative',
  justifyContent: 'center',
  placeItems: 'center'
});
